import { render, staticRenderFns } from "./CollectionRecordDetailsTable.vue?vue&type=template&id=fde6c42e&scoped=true"
import script from "./CollectionRecordDetailsTable.vue?vue&type=script&lang=js"
export * from "./CollectionRecordDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordDetailsTable.vue?vue&type=style&index=0&id=fde6c42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde6c42e",
  null
  
)

export default component.exports